import React from 'react';

import { Container, BoxImage } from './styles';

const Header = () => (
  <Container>
    <BoxImage>
      <img src="/images/logo-rappi-travel4business.svg" alt="logo-rappi" />
    </BoxImage>
  </Container>
);

export default Header;
